import ArrowBack from '@material-ui/icons/ArrowBack';
import PropTypes from 'prop-types';
import React from 'react';

import { Button } from 'components/AORedesign';

const BackToPaymentManagementButton = ({ handleOnClick }) => {
  return (
    <Button style={{ marginBottom: 16 }} startIcon={<ArrowBack />} size="small" variant="text" onClick={handleOnClick}>
      Back to Payment Management
    </Button>
  );
};
BackToPaymentManagementButton.propTypes = {
  handleOnClick: PropTypes.func, // accept a fn as a prop to go back to parent screen
};

export default BackToPaymentManagementButton;
